import { FileChunkUpload } from "src/app/core/services/file-upload/file-upload.service";
import { MediaCommitDto } from "src/models/ts/media-commit-dto.model";

export function mediaCommitDtoMapper(fileId: string, fileChunkUpload: FileChunkUpload ): MediaCommitDto {
	return {
		FileName: fileChunkUpload.fileName,
		LastModifiedDate: fileChunkUpload.lastModifiedDate.toString(),
		Identifier: fileId,
		Type: fileChunkUpload.type,
		Size: fileChunkUpload.size,
		ChunkIDs: fileChunkUpload.chunkIds,
		MediasID: 0,
		CollectionsID: 0,
		ContentType: "",
		MimeValidation: "",
		VersionsID: 0,
	};
}
